import {Component, inject, OnInit, signal} from '@angular/core';
import {Game} from '../../../../shared/model/game';
import {ApiResponse} from '../../../../shared/model/api-response';
import {GameCreateComponent} from './game-create/game-create.component';
import {BggBulkImportComponent} from '../bgg-bulk-import/bgg-bulk-import.component';
import {GameService} from '../../../../features/private/services/game.service';
import {Router} from '@angular/router';
import {NavigationHistoryService} from '../../../../core/services/navigation-history.service';

@Component({
  selector: 'app-game-add',
  standalone: true,
  imports: [GameCreateComponent, BggBulkImportComponent],
  templateUrl: './game-add.component.html',
  styleUrl: './game-add.component.css'
})
export class GameAddComponent implements OnInit {

  protected gameList = signal<Array<Game>>([]);
  protected activeTab = signal<'create' | 'bgg' | 'rpg'>('create');

  private gameService: GameService = inject(GameService);
  private router: Router = inject(Router);
  private navigationHistory = inject(NavigationHistoryService);

  ngOnInit(): void {
    this.loadAllGames();
  }

  loadAllGames() {
    this.gameService.getAllGames().subscribe((allGames) => {
      if (allGames.success && allGames.data) {
        this.gameList.set(allGames.data);
      }
    });
  }

  onGameAdded(game: Game) {
    this.gameService.submitGame(game).subscribe({
      next: (response: ApiResponse<Game>) => {
        if (response.success) {
          this.router.navigate(['/games']);
        }
      },
    });
  }

  onImportCompleted() {
    this.router.navigate(['/games']);
  }

  goBack() {
    this.navigationHistory.goBack(['/games']);
  }
}
